//nuitaLHotel.js

import React from 'react';
import Particles from 'react-particles';
//import {loadFull} from 'tsparticles';
import { useCallback } from 'react';
import { loadSlim } from "tsparticles-slim";
import './projet.css';

function NuitaLHotelDetail() {
      const imagep1 = require('./image/nuithotelcouloir.png');
      const imagep2 = require('./image/nuithotelenigme.png');
      const imagep3 = require('./image/monstre.png');

      const particlesInit = useCallback(async engine => {
        console.log(engine);
        // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        //await loadFull(engine);
        await loadSlim(engine);
      }, []);
  
      const particlesLoaded = useCallback(async container => {
          await console.log(container);
      }, []);

      return (
      <div className='flex'>
        <a href="/" className='back'>Back to Main Page</a>
        <h1>Nuit à l'Hôtel</h1>
        <p className='center'><i>Develop with Unreal Engine 5.3</i></p>
        <iframe width="560" height="315" title='Introduction Video' src="https://www.youtube.com/embed/SAIHva-o2wM"  allowFullScreen></iframe>
        <div className='download'><a href="https://fl3ur.itch.io/nuit-hotel" className='itchio'>Play the game on Itch.io</a></div>
      
      <div className="paragraph-container">

        <h3>Game Overview</h3>
        <p>The player finds themselves atop an abandoned hotel on a dark night. Their objective is to escape the hotel by descending through its various floors while surviving a menacing presence. The atmosphere is heavy, even oppressive, and the player must solve small puzzles to progress to the next floor within a time limit, with the looming "threat" becoming increasingly urgent as the player progresses. The player may uncover information about the situation as they progress.</p>

        <h3>Gameplay</h3>
        <p>The game is played in first person within a closed corridor environment. The player must solve simple puzzles that lead them through the different floors. The player must also avoid the "threat" by utilizing various hiding spots found within the hotel.</p>

        <h3>Story</h3>
        <p>While on vacation far from home, the character stops at a hotel to spend the night. However, upon waking up groggily and stumbling out of their room, they realize that something serious has happened at the hotel; traces of blood everywhere indicate that grave events have taken place. Now, there is only one thing left to do: survive and escape the hotel.</p>

        
        
        <div className="image-container">
          <div>
              <img src={imagep1} alt="imagep1"/>
              <div className="image-caption"><i>typical floor corridor.</i></div>
          </div>
          <div>
              <img src={imagep2} alt="imagep2"/>
              <div className="image-caption"><i>Blood message on the walls.</i></div>
          </div>
          <div>
              <img src= {imagep3} alt="imagep3"/>
              <div className="image-caption"><i>The monster chasing the player.</i></div>
          </div>
      </div>  

        <div className="columns">
        <div className="column">
            <h4>Developers</h4>
            <ul>
                <li>Antonin Bertus</li>
                <li>Antoine Yebouet</li>
                <li>François Dénès</li>
                <li>Hugo Denizot</li>
                <li>Thibault Boisseau</li>
            </ul>
        </div>

        <div className="column">
            <h4>Sound Designer</h4>
            Antoine Yebouet
        </div>

        <div className="column">
            <h4>Supervisor</h4>
            Sylvain Boivin, Ph. D.
        </div>
        </div>
        </div>
        <div className='particles-container'>
      <Particles 
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
            background: {
                color: {
                    value: "#0d47a1",
                },
            },
            fpsLimit: 120,
            interactivity: {
                events: {
                    onClick: {
                        enable: true,
                        mode: "push",
                    },
                    onHover: {
                        enable: true,
                        mode: "repulse",
                    },
                    resize: true,
                },
                modes: {
                    push: {
                        quantity: 4,
                    },
                    repulse: {
                        distance: 200,
                        duration: 0.4,
                    },
                },
            },
            particles: {
                color: {
                    value: "#ffffff",
                },
                links: {
                    color: "#ffffff",
                    distance: 150,
                    enable: true,
                    opacity: 0.5,
                    width: 1,
                },
                move: {
                    direction: "none",
                    enable: true,
                    outModes: {
                        default: "bounce",
                    },
                    random: false,
                    speed: 6,
                    straight: false,
                },
                number: {
                    density: {
                        enable: true,
                        area: 800,
                    },
                    value: 80,
                },
                opacity: {
                    value: 0.5,
                },
                shape: {
                    type: "circle",
                },
                size: {
                    value: { min: 1, max: 5 },
                },
            },
            detectRetina: true,
        }}
      />
      </div>
    </div>
    );
  }
  
  export default NuitaLHotelDetail;
